import { OperatorFunction } from 'rxjs';
import { catchError, startWith } from 'rxjs/operators';

export const catchSwitchMapError = <T, U, V>(
  errorAction: (error: V) => U
): OperatorFunction<T, T | U> =>
  catchError((error, innerSource) =>
    innerSource.pipe(startWith(errorAction(error)))
  );
